import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from '../icons/icon'

const Notification = props => {
  return (
    <div
      className={classNames({
        notification: true,
        [props.status]: true,
        [props.className]: props.className
      })}
    >
      {props.iconName ? <Icon name={props.iconName} /> : null}
      <div
        onClick={props.onClick}
        className={classNames({
          info: true,
          'tiny-text': props.small
        })}
      >
        {props.title ? <h3 className='title'>{props.title}</h3> : null}
        {props.children}
      </div>
      {props.onClose ? <Icon name='close' onClick={props.onClose} /> : null}
    </div>
  )
}

export const StatusTypes = {
  INFO: 'info',
  ERROR: 'error',
  WARNING: 'warning',
  SUCCESS: 'success',
  NEUTRAL: 'neutral'
}

Notification.propTypes = {
  // note to future maquetas: THIS IS A SHIT for developers
  // How do we know which classes are valid? what do they do?
  className: PropTypes.string,
  iconName: PropTypes.string,
  title: PropTypes.string,
  status: PropTypes.oneOf(['info', 'error', 'warning', 'success', 'neutral']),
  small: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func
}

export default Notification



// WEBPACK FOOTER //
// ./src/ui/notifications/notification.js